export const HONEYPOT_FIELD_NAME = "company_alt";

export interface FormSubmitResult {
  ok: boolean;
  message: string;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (typeof value === "object" && value !== null) {
    return value as Record<string, unknown>;
  }
  return null;
}

function pickString(source: Record<string, unknown> | null, key: string): string {
  if (!source) return "";
  const value = source[key];
  return typeof value === "string" ? value : "";
}

export function isHoneypotFilled(formEl: HTMLFormElement): boolean {
  const data = new FormData(formEl);
  const value = data.get(HONEYPOT_FIELD_NAME);
  return typeof value === "string" && value.trim() !== "";
}

export async function submitFormUrl(
  submitAddr: string,
  formEl: HTMLFormElement
): Promise<FormSubmitResult> {
  const formData = new FormData(formEl);
  const params = new URLSearchParams();

  formData.forEach((value, key) => {
    if (key === HONEYPOT_FIELD_NAME) return;
    if (typeof value === "string" && value.trim() !== "") {
      params.append(key, value);
    }
  });

  try {
    const response = await fetch(submitAddr, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params.toString(),
    });

    const responseText = await response.text();
    let parsed: unknown = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }

    const root = asRecord(parsed);
    const meta = asRecord(root ? root.meta : null);
    const code = pickString(root, "code");
    const serverMsg =
      pickString(meta, "message") ||
      pickString(root, "message") ||
      pickString(meta, "detail") ||
      responseText;

    const looksLikeSpam =
      /spam/i.test(serverMsg) || /form data is spam/i.test(responseText);

    if (!response.ok || code !== "OK" || looksLikeSpam) {
      return {
        ok: false,
        message: serverMsg || "提交未成功，请检查填写内容后重试。",
      };
    }

    return { ok: true, message: "提交成功，感谢你的来信。" };
  } catch {
    return { ok: false, message: "网络连接异常，请稍后重新提交。" };
  }
}